import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { createDocument } from '../../../api'
import { useInlineNotifications, useUserData } from '../../../hooks'
import { clearEmptyFields } from '../../../utils/formHelpers'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'

import {
  getDocumentFolderFormPayload,
  getDocumentFolderValidationSchema,
  getInitialValues,
} from './DocumentFolderForm.utils'
import { FormFields } from './FormFields'

function DocumentFolderForm({
  FormContainer,
  containerProps,
  getPayload = getDocumentFolderFormPayload,
  outboundUuid,
  parent,
  setModal,
  onCancel,
  onClose,
  onError,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const user = useUserData()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const initialValues = getInitialValues({ user })

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getPayload({
      outboundUuid,
      parent,
      values,
    })

    createDocument({ data: clearEmptyFields(payload), outboundUuid })
      .then(({ data }) => {
        onSuccess?.({
          id: data.id,
          name: data.name,
        })
      })
      .catch(({ response }) => {
        setSubmitting(false)

        if (isEmpty(response?.data)) {
          onError?.()
        } else {
          setErrors(parseServerValidation(response?.data))
        }
      })
  }

  const validationSchema = getDocumentFolderValidationSchema(t)

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FormFields
        {...restProps}
        notifications={notifications}
        outboundUuid={outboundUuid}
        setModal={setModal}
        onCancel={onCancel}
        onClose={onClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default DocumentFolderForm
